import React, { FC, ReactNode, useCallback } from "react";
import { useTranslation } from "react-i18next";
import { DialogActions, DialogActionsProps } from "../DialogActions";
import { useDialogWizardContext } from "./DialogWizardContext";

export type DialogWizardStepActionsProps = Pick<DialogActionsProps, "displayShadow" | "isWaiting" | "onCancel"> & {
  nextStepDisabled?: boolean;
  onNextStep?: VoidFunction;
  onPreviousStep?: VoidFunction;
  extraActions?: ReactNode;
};

const DialogWizardStepActions: FC<DialogWizardStepActionsProps> = ({
  displayShadow,
  isWaiting,
  extraActions,
  onCancel,
  nextStepDisabled,
  onPreviousStep,
  onNextStep,
}) => {
  const { t } = useTranslation("common");
  const {
    step,
    onPreviousStep: onWizardPreviousStep,
    stepsCount,
    onNextStep: onWizardNextStep,
  } = useDialogWizardContext();
  const backButtonText = t("actions.back2");
  const applyText = step !== stepsCount ? t("actions.next") : t("actions.ready");
  const onApply = useCallback(async () => {
    onNextStep && (await onNextStep());
    onWizardNextStep();
  }, [onWizardNextStep, onNextStep]);
  const onBackButton = useCallback(async () => {
    onPreviousStep && (await onPreviousStep());
    onWizardPreviousStep();
  }, [onWizardPreviousStep, onPreviousStep]);

  return (
    <DialogActions
      displayShadow={displayShadow}
      isWaiting={isWaiting}
      applyDisabled={nextStepDisabled}
      centered={false}
      onApply={onApply}
      onBackButton={step > 0 && onBackButton}
      backButtonText={backButtonText}
      onCancel={onCancel}
      applyText={applyText}
    >
      {extraActions}
    </DialogActions>
  );
};

export default DialogWizardStepActions;
